import { WidgetDefinition } from '../models/WidgetDefinition';

export const alarmsEvolutionWidgetDefinition: WidgetDefinition = {
    baseType: 'AlarmsEvolution',
    group: 'Charts',
    hasImage: true,
    highlights: ['Percentage of alarms over time'],
    icon: 'fa-line-chart',
    sortingOrder: 1700,
    title: 'Trend of Alarms',
    type: 'AlarmsEvolution'
};